import { IItem, instanceOfIItem } from "./IItem";

export interface IExtraPageRelationSettable extends IItem {
  isNote: boolean;
  relatedObjectKey: string;
  relatedObjectName: string;
  relationObjectId: string;
  relationObjectKey: string;
  relationObjectName: string;
  relatedObjectId: string;
  value: any;
  name: string;
  id: string;
}

export function instanceOfIExtraPageRelationSettable(instance: any): instance is IExtraPageRelationSettable {
  return instance
    && instance.isNote
    && instanceOfIItem(instance);
}
